import { memo, useEffect, useRef } from 'react'

import { useQuery } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'

import { Editor } from '@shared/components/Editor'
import type { EditorInstance } from '@shared/components/Editor'
import { LoadingIndicator, NotFound } from '@shared/layouts'
import { statusRoute } from 'pages/NWPlatform/AvcSystem/Instances/Instance/Task'
import { avcInstanceTaskQueryKeys } from 'services/queryKeys'
import { RefetchIntervals } from 'types/query'

const StatusRaw = () => {
  const { t } = useTranslation()

  const editorInstanceRef = useRef<EditorInstance>(undefined)

  const { avcInstanceId: instanceId, avcInstanceTaskId } = statusRoute.useParams()

  const avcInstanceTaskQuery = useQuery({
    ...avcInstanceTaskQueryKeys.detail({ instanceId, taskId: avcInstanceTaskId }),
    refetchInterval: RefetchIntervals.NORMAL,
  })
  const { data: avcInstanceTask } = avcInstanceTaskQuery

  useEffect(() => {
    if (editorInstanceRef.current && !!avcInstanceTask?.status) {
      editorInstanceRef.current?.getModel()?.setValue(window.JSON.stringify(avcInstanceTask?.status, null, 4))
    }
  }, [avcInstanceTask?.status])

  if (avcInstanceTaskQuery.isLoading) {
    return <LoadingIndicator />
  }

  if (!avcInstanceTask) {
    return <NotFound />
  }

  return (
    <Editor
      value={avcInstanceTask.status}
      readOnly
      readOnlyLabel={t('readOnlyAutoRefresh')}
      getEditorInstance={(editorInstance: EditorInstance) => (editorInstanceRef.current = editorInstance)}
    />
  )
}

export const Status = memo(StatusRaw)
